import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { descargar, imprimirPdf } from "@/lib/download";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Printer, Camera } from "lucide-react";

export const TAM_LBL = { IMPERIAL: "Imperial", SEMI: "Semi", MATRIMONIAL: "Matrimonial", QUEEN: "Queen", KING: "King", OTROS: "Otros" };
export const TAMANOS = Object.keys(TAM_LBL);
export const ESTADOS = [
  { v: "pendiente", l: "Pendiente", c: "bg-zinc-100 text-zinc-700" },
  { v: "en_proceso", l: "En proceso", c: "bg-blue-100 text-blue-800" },
  { v: "parcial", l: "Parcial", c: "bg-amber-100 text-amber-800" },
  { v: "terminado", l: "Terminado", c: "bg-emerald-100 text-emerald-800" },
  { v: "info_pendiente", l: "Información pendiente", c: "bg-purple-100 text-purple-800" },
];
export const estadoInfo = (v) => ESTADOS.find((e) => e.v === v) || ESTADOS[0];

export const BaseBadge = ({ info }) => {
  if (!info) return null;
  const e = estadoInfo(info.estado);
  return <span className={`text-[10px] font-semibold rounded px-1 ${e.c}`} data-testid="base-badge">Base: {e.l}{info.estado === "parcial" ? ` ${info.fabricadas}/${info.cantidad}` : ""}</span>;
};

export const ExportBar = ({ seccion, desde, hasta, testid }) => {
  const params = new URLSearchParams({ seccion, ...(desde ? { desde } : {}), ...(hasta ? { hasta } : {}) }).toString();
  const run = (fn) => fn().catch((e) => toast.error(String(e.message || e)));
  return (
    <div className="flex flex-wrap gap-2" data-testid={`bases-export-${testid || seccion}`}>
      <Button variant="outline" size="sm" className="gap-1" onClick={() => run(() => descargar(`/bases/reporte.xlsx?${params}`, `bases_${seccion}.xlsx`))} data-testid={`bases-xlsx-${testid || seccion}`}><Download className="w-4 h-4" /> Excel</Button>
      <Button variant="outline" size="sm" className="gap-1" onClick={() => run(() => descargar(`/bases/reporte.pdf?${params}`, `bases_${seccion}.pdf`))} data-testid={`bases-pdf-${testid || seccion}`}><Download className="w-4 h-4" /> PDF</Button>
      <Button variant="outline" size="sm" className="gap-1" onClick={() => run(() => imprimirPdf(`/bases/reporte.pdf?${params}`))} data-testid={`bases-print-${testid || seccion}`}><Printer className="w-4 h-4" /> Imprimir</Button>
    </div>
  );
};

export const Fotos = ({ fotos = [], id }) => (
  <div className="flex flex-wrap gap-1 max-w-[180px]" data-testid={`bases-fotos-${id}`}>
    {fotos.map((src, i) => <a key={i} href={src} target="_blank" rel="noreferrer"><img src={src} alt={`foto ${i + 1}`} loading="lazy" className="w-14 h-14 object-cover rounded border border-zinc-200" /></a>)}
  </div>
);

export const SubirFoto = ({ sid, onDone }) => {
  const [busy, setBusy] = useState(false);
  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const rd = new FileReader();
    rd.onload = async () => {
      setBusy(true);
      try { await api.post(`/bases/solicitudes/${sid}/fotos`, { foto_base64: rd.result }); toast.success("Foto agregada"); onDone(); }
      catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
    };
    rd.readAsDataURL(f);
    e.target.value = "";
  };
  return (
    <label className="text-[11px] text-zinc-500 hover:text-[#002FA7] inline-flex items-center gap-1 cursor-pointer" data-testid={`bases-foto-add-${sid}`}>
      <Camera className="w-3 h-3" /> {busy ? "Subiendo…" : "Foto"}
      <input type="file" accept="image/*" className="hidden" onChange={onFile} disabled={busy} />
    </label>
  );
};
